import { Flex, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { spacing } from "#app/theme/v2/spacing";
import { Text } from "#components/atoms/Typographies/Text";
import { Title } from "#components/atoms/Typographies/Title";
import { ONBOARDING_STEPS } from "#modules/onboardingV2/domain/onboardingSteps";
import { OnboardingV2Shell } from "#modules/onboardingV2/view/OnboardingV2Shell";
import { useTrackOnboardingStepViewed } from "#modules/onboardingV2/view/useOnboardingAnalytics";
import { Icon, IconName } from "#shared/icons/Icon";

const BENEFITS: {
  key: "instantQuotes" | "valuedHistory" | "allProcesses";
  icon: IconName;
}[] = [
  { key: "instantQuotes", icon: "lightning" },
  { key: "valuedHistory", icon: "history" },
  { key: "allProcesses", icon: "squareStack" },
];

export const OnboardingWelcomePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useTrackOnboardingStepViewed("welcome");

  return (
    <OnboardingV2Shell>
      <OnboardingV2Shell.Content>
        <Stack align="center" gap={spacing[12]}>
          <Stack align="center" gap={spacing[5]}>
            <Icon name="fabera" size={64} />
            <Stack align="center" gap={spacing[4]} maw={560}>
              <Title size="large" style={{ textAlign: "center" }}>
                {t("onboardingV2.welcome.title")}
              </Title>
              <Text color={colors.text.secondaryDefault} textAlign="center">
                {t("onboardingV2.welcome.subtitle")}
              </Text>
            </Stack>
          </Stack>

          <Stack gap={spacing[6]}>
            {BENEFITS.map((benefit) => (
              <Flex key={benefit.key} gap={spacing[5]} align="center" w={640}>
                <Flex
                  justify="center"
                  align="center"
                  w={spacing[16]}
                  h={spacing[16]}
                  style={{
                    backgroundColor: colors.bg.elevation.tertiary,
                    borderRadius: radius.sm,
                    flexShrink: 0,
                  }}
                >
                  <Icon name={benefit.icon} size={24} color={colors.icon.primaryDefault} />
                </Flex>
                <Stack gap={spacing[1]}>
                  <Text type="bold">{t(`onboardingV2.welcome.benefits.${benefit.key}.title`)}</Text>
                  <Text size="small" color={colors.text.secondaryDefault}>
                    {t(`onboardingV2.welcome.benefits.${benefit.key}.description`)}
                  </Text>
                </Stack>
              </Flex>
            ))}
          </Stack>
        </Stack>
      </OnboardingV2Shell.Content>

      <OnboardingV2Shell.Footer
        buttonLabel={t("onboardingV2.welcome.start")}
        onContinue={() => navigate(ONBOARDING_STEPS.activityType.path)}
      />
    </OnboardingV2Shell>
  );
};
